import React from "react";
import { useTrans } from "@/utils/useTrans";

export const TactsuitSleeveInteractionScrollInfo = () => {
  const { t } = useTrans(["tactsuit"]);

  return (
    <div className="align-center labtop:py-0 flex w-full flex-col justify-center overflow-hidden bg-white px-3 py-6 pb-1 laptop:bg-coolgray-10 desktop:pl-[122px]">
      <div className="px-3">
        <h2 className="text-3xl laptop:text-5xl">
          {t("Half the Weight, Double the Freedom")}
        </h2>
        <p className="mt-5 whitespace-normal text-base laptop:whitespace-pre-line laptop:text-lg">
          {t(
            "Experience unrestricted arm movement with a lightweight design, ensuring you stay immersed without any discomfort.",
          )}
        </p>
      </div>
    </div>
  );
};
